"use client";

// packages/react/focus-guards/src/focus-guards.tsx
import * as React from "react";
var count = 0;
function FocusGuards(props) {
  useFocusGuards();
  return props.children;
}
function useFocusGuards() {
  React.useEffect(function () {
    var _edgeGuards$, _edgeGuards$2;
    var edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : createFocusGuard());
    count++;
    return function () {
      if (count === 1) {
        document.querySelectorAll("[data-radix-focus-guard]").forEach(function (node) {
          return node.remove();
        });
      }
      count--;
    };
  }, []);
}
function createFocusGuard() {
  var element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.outline = "none";
  element.style.opacity = "0";
  element.style.position = "fixed";
  element.style.pointerEvents = "none";
  return element;
}
var Root = FocusGuards;
export { FocusGuards, Root, useFocusGuards };